<template>
  <div class="recruitment-settings">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>招聘服务费用设置</span>
      </div>
      
      <el-form 
        ref="form" 
        :model="form" 
        :rules="rules" 
        label-width="180px"
        label-position="left"
      >
        <!-- 月费设置 -->
        <el-form-item label="月费价格（元）" prop="monthlyFee">
          <el-input-number 
            v-model="form.monthlyFee" 
            :min="0" 
            :precision="2" 
            :step="100"
            controls-position="right"
          />
          <div class="form-tip">企业每月支付此费用可享受招聘服务</div>
        </el-form-item>
        
        <!-- 每月可发布职位数量 -->
        <el-form-item label="每月可发布职位数" prop="monthlyJobLimit">
          <el-input-number 
            v-model="form.monthlyJobLimit" 
            :min="1" 
            :step="1"
            controls-position="right"
          />
          <div class="form-tip">购买月费后可发布的招聘职位数量</div>
        </el-form-item>
        
        <!-- 单次发布费用 -->
        <el-form-item label="单次发布价格（元）" prop="singlePostFee">
          <el-input-number 
            v-model="form.singlePostFee" 
            :min="0" 
            :precision="2" 
            :step="10"
            controls-position="right"
          />
          <div class="form-tip">企业不购买月费时，单次发布招聘职位的费用</div>
        </el-form-item>
        
        <!-- 单次发布有效期 -->
        <el-form-item label="单次发布有效期（天）" prop="singlePostExpireDays">
          <el-input-number 
            v-model="form.singlePostExpireDays" 
            :min="1" 
            :step="1"
            controls-position="right"
          />
          <div class="form-tip">单次发布的招聘信息有效天数</div>
        </el-form-item>
        
        <!-- 是否启用招聘功能 -->
        <el-form-item label="启用招聘功能" prop="enabled">
          <el-switch v-model="form.enabled"></el-switch>
        </el-form-item>
        
        <!-- 提交按钮 -->
        <el-form-item>
          <el-button type="primary" @click="submitForm" :loading="loading">保存设置</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      idCardFront: '',
      idCardBack: '',
      license: '',
      licenseNumber: '',
      businessAddress: ''
    }
  },
  computed: {
    isFormComplete() {
      return this.idCardFront && 
             this.idCardBack && 
             this.license && 
             this.licenseNumber && 
             this.businessAddress;
    }
  },
  methods: {
    handleUpload(type) {
      uni.chooseImage({
        count: 1,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: (res) => {
          const tempFilePath = res.tempFilePaths[0];
          switch(type) {
            case 'idCardFront':
              this.idCardFront = tempFilePath;
              break;
            case 'idCardBack':
              this.idCardBack = tempFilePath;
              break;
            case 'license':
              this.license = tempFilePath;
              break;
          }
        }
      });
    },
    handleSubmit() {
      if (!this.isFormComplete) {
        return;
      }
      uni.showLoading({
        title: '提交中'
      });
      
      setTimeout(() => {
        uni.hideLoading();
        uni.showToast({
          title: '提交成功',
          icon: 'success'
        });
      }, 2000);
    }
  }
}
</script>

<style lang="scss" scoped>
.recruitment-settings {
  padding: 20px;
  
  .box-card {
    margin-bottom: 20px;
    
    .clearfix {
      font-size: 18px;
      font-weight: bold;
    }
  }
  
  .form-tip {
    font-size: 12px;
    color: #999;
    margin-top: 5px;
  }
  
  /deep/ .el-input-number {
    width: 200px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/setting/recruitment/recruitment.vue